import { _converse, api, MUC, Model } from '@converse/headless';
import { ObservableElement } from 'shared/components/observable.js';
import tplMUCOccupant from './templates/occupant.js';
import './occupant-bottom-panel.js';

export default class MUCOccupantListItem extends ObservableElement {
    /**
     * @typedef {import('shared/components/types').ObservableProperty} ObservableProperty
     */

    constructor() {
        super();
        this.muc = null;
        this.observable = /** @type {ObservableProperty} */ ('once');
    }

    static get properties() {
        return {
            ...super.properties,
            model: { type: Model },
            muc: { type: MUC },
        };
    }

    async initialize() {
        super.initialize();
        await this.muc.initialized;
        this.listenTo(this.model, 'change', () => this.requestUpdate());
        this.listenTo(this.model, 'vcard:add', () => this.requestUpdate());
        this.listenTo(this.model, 'vcard:change', () => this.requestUpdate());
        this.requestUpdate();
    }

    render() {
        return this.muc ? tplMUCOccupant(this) : '';
    }

    /**
     * @param {MouseEvent} ev
     * @param {import('@converse/headless/types/plugins/muc/occupant.js').default} occupant
     */
    onOccupantClicked(ev, occupant) {
        ev.preventDefault();
        console.log('Клик по участнику:', occupant);

        // Получаем JID текущего пользователя (твой собственный)
        const own_jid = _converse.session.get('bare_jid');
        // Получаем JID участника, по которому кликнули
        const occupant_jid = occupant.get('jid');
        console.log(own_jid, occupant_jid);
        // Сравниваем JID-ы
        if (occupant_jid === own_jid) {
            // Это Я — показываем модалку профиля
            api.modal.show('sonata-profile-modal', { model: _converse.state.xmppstatus }, ev);
        } else {
            // Это КТО-ТО ДРУГОЙ — показываем модалку участника MUC
            api.modal.show('converse-muc-occupant-modal', { 'model': occupant }, ev);
        }
    }
}

api.elements.define('converse-muc-occupant-list-item', MUCOccupantListItem);
